import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionRecheckXCardStatusRequest } from '../../../xcard/actions';
import { getHasXCard, getIsXCardActive, getRecheckXCardStatusError } from '../../../xcard/selectors';


export default ({ getState, dispatch }) => (
  function recheckXCardStatusHandler(nextState, successCallback, errorCallback) {
    if (!getHasXCard(getState()) || getIsXCardActive(getState())) {
      successCallback();
      return;
    }

    dispatch(
      actionRecheckXCardStatusRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getRecheckXCardStatusError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('recheckXCardStatusHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
